/**
 * Shared WebSocket readiness checks for Gemini Live (@google/genai session).
 */

const WS_OPEN = typeof WebSocket !== 'undefined' ? WebSocket.OPEN : 1;

/**
 * @param {import('@google/genai').Session | null} session
 * @returns {number|undefined}
 */
export const getLiveSocketReadyState = (session) => {
  const c = session?.conn;
  if (!c) return undefined;
  if (typeof c.readyState === 'number') return c.readyState;
  if (c.ws && typeof c.ws.readyState === 'number') return c.ws.readyState;
  return undefined;
};

/** @param {import('@google/genai').Session | null} session */
export const isLiveSessionSendReady = (session) => getLiveSocketReadyState(session) === WS_OPEN;

export { WS_OPEN as GEMINI_LIVE_WS_OPEN };
